import { USER_ROLES } from 'helpers/constants';

export const USERS_ACTIONS = {
    SET_USERS: 'SET_USERS',
    SET_USER: 'SET_USER',
    SHOW_USER_FORM_MODAL: 'SHOW_USER_FORM_MODAL',
    HIDE_USER_FORM_MODAL: 'HIDE_USER_FORM_MODAL',
    SHOW_DEACTIVATE_USER_DIALOG: 'SHOW_DEACTIVATE_USER_DIALOG',
    HIDE_DEACTIVATE_USER_DIALOG: 'HIDE_DEACTIVATE_USER_DIALOG',
    RELOAD_USERS: 'RELOAD_USERS'
};

const USER_FORM_INITIAL_VALUES = {
    firstName: '',
    lastName: '',
    jobTitle: '',
    department: '',
    dateOfBirth: '',
    idType: '',
    idNumber: '',
    email: '',
    phoneNumber: '',
    id_role: USER_ROLES.ADMIN
};

export const INITIAL_STATE = {
    users: [],
    total: 0,
    user: USER_FORM_INITIAL_VALUES,
    previousUser: USER_FORM_INITIAL_VALUES,
    reloadUsers: 0,
    isUserFormModalOpen: false,
    isDeactivateUserDialogOpen: false
};

export default function usersReducer(state, action) {
    switch (action.type) {
        case USERS_ACTIONS.SET_USERS:
            return {
                ...state,
                users: action.payload.results,
                total: action.payload.total
            };
        case USERS_ACTIONS.SET_USER:
            return {
                ...state,
                user: action.payload,
                previousUser: {
                    id: action.payload.id,
                    firstName: action.payload.first_name,
                    lastName: action.payload.last_name,
                    jobTitle: action.payload.job_title,
                    department: action.payload.department,
                    email: action.payload.email,
                    phoneNumber: action.payload.phone_number?.substring(2),
                    id_role: action.payload.id_role
                }
            };
        case USERS_ACTIONS.SHOW_USER_FORM_MODAL:
            return { ...state, isUserFormModalOpen: true };
        case USERS_ACTIONS.HIDE_USER_FORM_MODAL:
            return {
                ...state,
                isUserFormModalOpen: false,
                user: USER_FORM_INITIAL_VALUES
            };
        case USERS_ACTIONS.SHOW_DEACTIVATE_USER_DIALOG:
            return { ...state, isDeactivateUserDialogOpen: true };
        case USERS_ACTIONS.HIDE_DEACTIVATE_USER_DIALOG:
            return { ...state, isDeactivateUserDialogOpen: false };
        case USERS_ACTIONS.RELOAD_USERS:
            return { ...state, reloadUsers: state.reloadUsers + 1 };
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
}
